import React, { useContext, useState } from 'react'
import { OffreModel } from '../types/OffreModel'
import { FormattedMessage } from 'react-intl'
import { ResponsiveContext } from '../../../utils/context/ResponsiveContext'
import styles from '../../../styles'
import Button from '../../../components/button/Button'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'

const useStyles = makeStyles<{ isLargeScreen: boolean }>()(
	(theme, { isLargeScreen }) => ({
		titre: {
			...styles(theme).title0,
			fontSize: isLargeScreen ? 35 : 22,
			marginBottom: isLargeScreen ? 28 : 24,
			marginTop: 0
		},
		atoutContainer: {
			marginBottom: isLargeScreen ? 25 : 20,

			'& img': {
				objectFit: 'contain'
			}
		},
		atoutTexte: {
			...styles(theme).text2,
			marginLeft: isLargeScreen ? 20 : 12
		},
		boutonStyle: {
			marginTop: 10,
			borderRadius: 25,
			border: '1px solid #D0D5DA',
			boxShadow: '0px 0px 62px #1229411C'
		}
	})
)

interface AcceptingProps {
	offre: OffreModel
}

type AtoutsProps = AcceptingProps

const Atouts: React.FC<AtoutsProps> = (
	{
		offre
	}
) => {
	const { isLargeScreen } = useContext(ResponsiveContext)
	const { classes } = useStyles({ isLargeScreen })
	const [voirPlus, setVoirPlus] = useState(false)

	return (
		<Grid container item xs={12}>
			<Grid item xs={12}>
				<h2 className={classes.titre}>
					<FormattedMessage
						id="offre.atouts.titre"
						defaultMessage="Les atouts de ce bien"
						description="Titre des atouts"
					/>
				</h2>
			</Grid>

			{/* Listing des atouts de l'offre */}
			<Grid container item xs={12}>
				{
					// Si on est en mobile et que l'utilisateur n'a pas cliqué sur "Afficher plus d'atouts", alors on ne renvoie que les 5 premiers éléménts des atouts
					(!isLargeScreen && !voirPlus ? offre.atouts.slice(0, 5) : offre.atouts).map(
						(atout, index) => (
							<Grid container item xs={12} md={4} alignItems="center" key={`atout-${atout.texte}-${index}`} className={classes.atoutContainer}>
								<img src={atout.icone} alt={atout.texte} width={30} height={30} />
								<span className={classes.atoutTexte}>{atout.texte}</span>
							</Grid>
						)
					)
				}

				{
					// Si on est en mobile, que l'utilisateur n'a pas cliqué sur "Afficher plus d'atouts" et qu'il y a > 5 atouts, alors on affiche le bouton "Afficher ...."
					!isLargeScreen && !voirPlus && offre.atouts.length > 5 && (
						<Button
							background="backgroundWhite"
							color="colorBlue"
							textStyle="text4"
							onClick={() => setVoirPlus(true)}
							buttonStyle={classes.boutonStyle}
						>
							<FormattedMessage
								id="offre.atouts.bouton"
								defaultMessage="Afficher plus d'atouts"
								description="Bouton pour afficher plus d'atouts en mobile"
							/>
						</Button>
					)
				}
			</Grid>
		</Grid>
	)
}

export default Atouts